<template>
  <v-container class="py-10">
    <!-- ENCABEZADO -->
    <v-row class="mb-6" align="center" justify="space-between">
      <v-col cols="12" md="6">
        <div style="font-family: 'montserrat-bold'; font-size: 28px; color: #000000;">
          Facturas de {{ nombreDeudor }}
        </div>
        <div style="font-family: 'montserrat-regular'; font-size: 14px;">
          Aquí puedes consultar todas las facturas asociadas a este deudor.
        </div>
      </v-col>

      <!-- RESUMEN -->
      <v-col cols="12" md="6" class="d-flex justify-end">
        <v-card class="py-6 px-6" style="background-color: #f5f5f5; border-radius: 24px; width: 100%; max-width: 550px; box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.75);">
          <div style="font-family: 'montserrat-semibold'; font-size: 18px; margin-bottom: 10px;">
            Resumen de deuda
          </div>
          <v-row>
            <v-col cols="6">
              <div><strong>Pend. aprobar</strong></div>
              <div>{{ "$" + formatMoney(resumen.pendientes) + " USD" }}</div>
            </v-col>
            <v-col cols="6">
              <div><strong>Pend. pagar</strong></div>
              <div>{{ "$" + formatMoney(resumen.porPagar) + " USD" }}</div>
            </v-col>
            <v-col cols="6">
              <div><strong>Vencido</strong></div>
              <div class="red--text">{{ "$" + formatMoney(resumen.vencido) + " USD" }}</div>
            </v-col>
            <v-col cols="6">
              <div><strong>Pagado</strong></div>
              <div class="green--text">{{ "$" + formatMoney(resumen.pagado) + " USD" }}</div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <!-- BUSCADOR -->
    <v-row class="mb-6" align="center">
      <v-col cols="12" md="6">
        <v-text-field
          v-model="busqueda"
          placeholder="Buscar factura"
          clearable
          hide-details
          outlined
          prepend-inner-icon="mdi-magnify"
          style="width: 300px; font-family: 'montserrat-medium'; border-radius: 20px;"
        />
      </v-col>
    </v-row>

    <!-- FACTURAS AGRUPADAS POR ESTADO -->
    <v-expansion-panels multiple accordion>
      <v-expansion-panel class="mb-4" style="border-radius: 15px;">
        <v-expansion-panel-header class="py-8" style="font-family: 'montserrat-semibold'; font-size: 16px;">
          Pendientes por aprobar ({{ invoicesPorEstado['validada']?.length || 0 }})
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row
            v-for="factura in invoicesPorEstado['validada']"
            :key="factura.id"
            class="py-3 px-2 align-center"
            style="border-bottom: 1px solid #e0e0e0;"
          >
            <v-col cols="8" @click="abrirDetalle(factura)">
              <div style="font-family: 'montserrat-bold'; font-size: 15px;">
                #{{ factura.id }} — {{ factura.cedente_name }}
              </div>
              <div style="font-size: 13px; color: #777;">
                Fecha de carga: {{ formatDate(factura.created_at) }}
              </div>
              <div style="font-size: 13px; color: #000;">
                Monto: {{ formatMoney(factura.monto_total) }} USD
                <span v-if="factura.deposito"> | Depósito: {{ formatMoney(factura.deposito) }} USD</span>
              </div>
              <div v-if="factura.fechaAprobacion" style="font-size: 12px; color: #888;">
                Aprobada: {{ factura.fechaAprobacion }}
              </div>
              <div v-if="factura.fechaLiquidacion" style="font-size: 12px; color: #888;">
                Liquidada: {{ factura.fechaLiquidacion }}
              </div>
            </v-col>

            <v-col cols="4" class="text-right d-flex align-center justify-end">
              <v-btn
                color="#0275b8"
                class="white--text"
                v-if="factura.estado == 'CARGADA' || factura.estatus == 'liquidada'"
                rounded
                small
                style="text-transform: none; font-weight: 600;"
                @click="accion(factura)"
              >
                {{ accionesPorEstado[factura.estado] }}
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel class="mb-4" style="border-radius: 15px;">
        <v-expansion-panel-header class="py-8" style="font-family: 'montserrat-semibold'; font-size: 16px;">
          Pendientes de pagar ({{ invoicesPorEstado['adelantada']?.length || 0 }})
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row
            v-for="factura in invoicesPorEstado['adelantada']"
            :key="factura.id"
            class="py-3 px-2 align-center"
            style="border-bottom: 1px solid #e0e0e0;"
          >
            <v-col cols="8" @click="abrirDetalle(factura)">
              <div style="font-family: 'montserrat-bold'; font-size: 15px;">
                #{{ factura.id }} — {{ factura.cedente_name }}
              </div>
              <div style="font-size: 13px; color: #777;">
                Fecha de carga: {{ formatDate(factura.created_at) }}
              </div>
              <div style="font-size: 13px; color: #000;">
                Monto: {{ formatMoney(factura.monto_total) }} USD
                <span v-if="factura.deposito"> | Depósito: {{ formatMoney(factura.deposito) }} USD</span>
              </div>
              <div v-if="factura.fechaAprobacion" style="font-size: 12px; color: #888;">
                Aprobada: {{ factura.fechaAprobacion }}
              </div>
              <div v-if="factura.fechaLiquidacion" style="font-size: 12px; color: #888;">
                Liquidada: {{ factura.fechaLiquidacion }}
              </div>
            </v-col>

            <v-col cols="4" class="text-right d-flex align-center justify-end">
              <v-btn
                color="#0275b8"
                class="white--text"
                v-if="factura.estado == 'CARGADA' || factura.estatus == 'liquidada'"
                rounded
                small
                style="text-transform: none; font-weight: 600;"
                @click="accion(factura)"
              >
                {{ accionesPorEstado[factura.estado] }}
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel class="mb-4" style="border-radius: 15px;">
        <v-expansion-panel-header class="py-8" style="font-family: 'montserrat-semibold'; font-size: 16px;">
          Liquidadas ({{ invoicesPorEstado['cobrada']?.length || 0 }})
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row
            v-for="factura in invoicesPorEstado['cobrada']"
            :key="factura.id"
            class="py-3 px-2 align-center"
            style="border-bottom: 1px solid #e0e0e0;"
          >
            <v-col cols="8" @click="abrirDetalle(factura)">
              <div style="font-family: 'montserrat-bold'; font-size: 15px;">
                #{{ factura.id }} — {{ factura.cedente_name }}
              </div>
              <div style="font-size: 13px; color: #777;">
                Fecha de carga: {{ formatDate(factura.created_at) }}
              </div>
              <div style="font-size: 13px; color: #000;">
                Monto: {{ formatMoney(factura.monto_total) }} USD
                <span v-if="factura.deposito"> | Depósito: {{ formatMoney(factura.deposito) }} USD</span>
              </div>
              <div v-if="factura.fechaAprobacion" style="font-size: 12px; color: #888;">
                Aprobada: {{ factura.fechaAprobacion }}
              </div>
              <div v-if="factura.fechaLiquidacion" style="font-size: 12px; color: #888;">
                Liquidada: {{ factura.fechaLiquidacion }}
              </div>
            </v-col>

            <v-col cols="4" class="text-right d-flex align-center justify-end">
              <v-btn
                color="#0275b8"
                class="white--text"
                v-if="factura.estado == 'CARGADA' || factura.estatus == 'liquidada'"
                rounded
                small
                style="text-transform: none; font-weight: 600;"
                @click="accion(factura)"
              >
                {{ accionesPorEstado[factura.estado] }}
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>


    <!-- DIALOG: APROBACIÓN -->
    <v-dialog v-model="dialogAprobar" max-width="500px">
      <v-card style="border-radius: 20px; padding: 24px;">
        <!-- Encabezado -->
        <div style="font-family: 'montserrat-bold'; font-size: 22px;">Factura #{{ factura.id }}</div>
        <div class="mb-2" style="font-family: 'montserrat-semibold'; font-size: 16px; color: #333;">{{ factura.cliente }}</div>

        <!-- Advertencia -->
        <div class="mb-2" style="background-color: #FFF8E4; display: flex; align-items: center; border-radius: 12px; padding: 16px;">
          <div class="mr-4" style="border-right: #FCCA3D solid 4px; height: 100px"></div>
          <div style="display: flex; flex-direction: column;">
            <div style="font-family: 'montserrat-bold'; font-size: 16px; color: #2E404E; margin-bottom: 8px;">
              {{ 'Esta factura aún no ha sido aprobada. Debes examinarla detenidamente antes de tomar cualquier acción.' }}
            </div>
          </div>
        </div>

        <!-- Monto -->
        <div class="mb-3">
          <div style="font-family: 'montserrat-medium'; font-size: 14px;">Monto de la factura</div>
          <div style="font-size: 24px; font-weight: bold;">${{ formatMoney(factura.monto) }} USD</div>
        </div>

        <!-- Fechas -->
        <v-row dense>
          <v-col cols="6">
            <div style="font-size: 12px; color: #888;">VENCIMIENTO</div>
            <div>{{ factura.fechaVencimiento }}</div>
          </v-col>
          <v-col cols="6">
            <div style="font-size: 12px; color: #888;">FECHA DE CARGA</div>
            <div>{{ factura.fechaCarga }}</div>
          </v-col>
        </v-row>

        <!-- Cliente -->
        <div class="mt-3" style="font-size: 12px; color: #888;">CLIENTE</div>
        <div style="font-size: 14px;">{{ factura.cliente }}</div>

        <!-- Términos -->
        <div style="display: flex;">
          <v-btn text small class="mt-4" color="primary" @click="verTerminos">
            Ver términos y condiciones
          </v-btn>
        </div>

        <!-- Acción -->
        <v-btn
          block
          large
          color="black"
          class="white--text mt-4"
          style="border-radius: 10px; text-transform: none; font-weight: 600;"
          @click="aprobarFactura"
        >
          Aprobar factura
        </v-btn>
      </v-card>
    </v-dialog>
    
    <!-- DIALOG: LIQUIDACIÓN -->
    <v-dialog v-model="dialogLiquidar" max-width="500px">
      <v-card style="border-radius: 20px; padding: 24px;">
        <!-- Encabezado -->
        <div style="font-family: 'montserrat-bold'; font-size: 22px;">Liquidar factura #{{ factura.id }}</div>
        <div class="mb-2" style="font-family: 'montserrat-semibold'; font-size: 16px; color: #333;">{{ factura.cliente }}</div>

        <!-- Información fija -->
        <div class="mb-3 mt-4">
          <div style="font-family: 'montserrat-medium'; font-size: 14px;">Monto total</div>
          <div style="font-size: 24px; font-weight: bold;">${{ formatMoney(factura.monto) }} USD</div>
        </div>

        <!-- Método de pago -->
        <v-autocomplete
          v-model="metodoLiquidacion"
          :items="['Fresher Account', 'Otro']"
          label="Método de liquidación"
          outlined
          dense
          class="mt-2"
        />

        <!-- Fecha manual solo si es 'Otro' -->
        <v-menu
          v-if="metodoLiquidacion === 'Otro'"
          ref="menuFecha"
          v-model="menuFecha"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="fechaDeposito"
              label="Fecha de depósito"
              prepend-icon="mdi-calendar"
              readonly
              outlined
              dense
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker v-model="fechaDeposito" @input="menuFecha = false" />
        </v-menu>

        <!-- Acción -->
        <v-btn
          block
          large
          color="black"
          class="white--text mt-4"
          style="border-radius: 10px; text-transform: none; font-weight: 600;"
          @click="confirmarLiquidacion"
        >
          {{ metodoLiquidacion === 'Otro' ? 'Registrar liquidación' : 'Liquidar factura' }}
        </v-btn>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      nombreDeudor: 'Comprador Global',
      busqueda: '',
      invoices: [],
      facturas: [
        { id: 201, cliente: 'ACME S.A.', estado: 'PENDIENTE_APROBACION', fecha: '2025-06-01', monto: 50000, fechaVencimiento: '2025-07-01' },
        { id: 202, cliente: 'Logística Fénix', estado: 'PENDIENTE_APROBACION', fecha: '2025-06-02', monto: 80000, fechaVencimiento: '2025-07-02' },
        { id: 203, cliente: 'ACME S.A.', estado: 'PENDIENTE_PAGO', fecha: '2025-05-25', monto: 95000, deposito: 75000, fechaVencimiento: '2025-06-25' },
        { id: 204, cliente: 'Logística Fénix', estado: 'PENDIENTE_PAGO', fecha: '2025-05-27', monto: 88000, deposito: 70000, fechaVencimiento: '2025-06-27' },
        { id: 205, cliente: 'ACME S.A.', estado: 'PAGADA', fecha: '2025-04-20', monto: 60000, fechaPago: '2025-05-20' },
        { id: 206, cliente: 'Logística Fénix', estado: 'PAGADA', fecha: '2025-04-22', monto: 62000, fechaPago: '2025-05-22' }
      ],
      factura: {
        id: 104,
        cliente: 'Logística Fénix',
        estado: 'PENDIENTE_APROBACION',
        fechaCarga: '2025-06-10',
        fechaAprobacion: null,
        fechaLiquidacion: null,
        monto: 98000,
        montoPagado: null
      },
      etiquetas: {
        PENDIENTE_APROBACION: 'Pendientes por aprobar',
        PENDIENTE_PAGO: 'Pendientes por pagar',
        PAGADA: 'Pagadas'
      },
      accionesPorEstado: {
        PENDIENTE_APROBACION: 'Aprobar',
        PENDIENTE_PAGO: 'Pagar',
        PAGADA: 'Ver detalle'
      },
      dialogAgregar: false,
      nuevoCliente: null,
      clientesAsociados: [
        { id: 1, nombre: 'ACME S.A.', facturas: 12, lineaUsada: 450000 },
        { id: 2, nombre: 'Logística Fénix', facturas: 7, lineaUsada: 300000 }
      ],
      clientesDisponibles: [
        { id: 3, nombre: 'Transportes Delta' },
        { id: 4, nombre: 'Servicios Andinos' }
      ],
      headers: [
        { text: 'Cliente cedente', value: 'nombre' },
        { text: 'Facturas', value: 'facturas', align: 'center' },
        { text: 'Línea usada', value: 'linea', align: 'center' },
        { text: 'Acciones', value: 'actions', align: 'center', sortable: false }
      ],
      dialogAprobar: false,
      dialogLiquidar: false,
      metodoLiquidacion: null,
      fechaDeposito: null,
      menuFecha: false,
    }
  },
  computed: {
    facturasFiltradas() {
      if (!this.busqueda) return this.facturas;
      const query = this.busqueda.toLowerCase();
      return this.facturas.filter(f =>
        String(f.id).includes(query) ||
        f.fecha.toLowerCase().includes(query) ||
        String(f.monto).includes(query)
      );
    },
    invoicesPorEstado() {
      if (!Array.isArray(this.invoices)) return {}; 

      return this.invoices.reduce((acc, factura) => {
        const estado = factura.estatus || 'SIN_ESTADO';
        if (!acc[estado]) {
          acc[estado] = [];
        }
        acc[estado].push(factura);
        return acc;
      }, {});
    },
    resumen() {
      const sum = (estado) =>
        this.invoices
          .filter(f => f.estatus === estado)
          .reduce((acc, f) => acc + Number(f.monto_total), 0);

      const hoy = new Date();

      const vencido = this.invoices
        .filter(
          f =>
            f.estatus === 'adelantada' &&
            new Date(f.fechaVencimiento) < hoy
        )
        .reduce((acc, f) => acc + Number(f.monto_total), 0);

      return {
        pendientes: sum('validada'),
        porPagar: sum('adelantada'),
        vencido,
        pagado: sum('cobrada')
      };
    }
  },
  methods: {
    async getInvoices() {
      try {
        this.isLoading = true;
        const response = await DB.get(`${URI}/api/v1/en/factoringInvoices/debtor/${this.$route.params.deudorId}`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        this.isLoading = false;
        this.invoices = response.data.factoringInvoices || [];
      } catch (error) {
        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      } finally {
        this.isLoading = false;
      }
    },
    formatMoney(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM DD, YYYY");
      return formattedDate;
    },
    abrirDetalle(factura) {
      this.$router.push({
        name: 'FacturaDeudorDetalle',
        params: { id: factura.id }
      });
    },
    verTerminos() {
      // Aquí iría la lógica para mostrar los términos y condiciones
    },
    accion(factura) {
      if (factura.estado === 'PENDIENTE_APROBACION') {
        this.dialogAprobar = true;
      } else if (factura.estado === 'PENDIENTE_PAGO') {
        this.dialogLiquidar = true;
      } else if (factura.estado === 'PAGADA') {
        this.abrirDetalle(factura);
      }
    },
    editarCliente(cliente) {
      // Aquí iría lógica o modal de edición si se desea
    },
    quitarCliente(cliente) {
      this.clientesAsociados = this.clientesAsociados.filter(c => c.id !== cliente.id);
    },
    confirmarAgregarCliente() {
      const cliente = this.clientesDisponibles.find(c => c.id === this.nuevoCliente);
      if (cliente) {
        this.clientesAsociados.push({
          id: cliente.id,
          nombre: cliente.nombre,
          facturas: 0,
          lineaUsada: 0
        });
        this.clientesDisponibles = this.clientesDisponibles.filter(c => c.id !== cliente.id);
        this.dialogAgregar = false;
        this.nuevoCliente = null;
      }
    },
    aprobarFactura() {
      this.dialogAprobar = false;
    },
    confirmarLiquidacion() {
      this.dialogLiquidar = false;
      this.metodoLiquidacion = null;
      this.fechaDeposito = null;
    },
  },
  beforeMount() {
    this.getInvoices();
  },
};
</script>

<style>
.v-expansion-panel:not(:first-child)::after {
  border-top: none !important;
}
</style>
